// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* footer-area */
.footer-area {
    background-color: #0b59ae;
    text-align: center;
    padding: 70px 0 50px;
    color: #fff;
  }
  .followus_box h4 {
    font-weight: 600;
    text-transform: uppercase;
    font-size: 24px;
    letter-spacing: 0.5px;
    margin-bottom: 5px;
  }
  .followus_box a {
    color: #fff;
    font-size: 30px;
  }
  
  .footer-menu ul li a {
    color: rgb(255 255 255 / 79%);
    font-size: 16px;
    padding: 14px;
    display: inline-block;
    position: relative;
    font-weight: 300;
  }
  .footer-menu ul li a:hover {
    color: #fff;
  }
  .footer-menu ul li:last-child a::after {
    display: none;
  }
  .footer-menu ul li a::after {
    content: "";
    position: absolute;
    width: 1px;
    height: 18px;
    background-color: rgb(255 255 255 / 46%);
    right: -5px;
    top: 16px;
  }
  .footer-area .appbox {
    margin: 15px 0;
  }
  .footer-area .appbox h4 {
    margin-bottom: 15px;
    font-size: 24px;
    font-weight: 600;
  }
  .footer-area .appbox img {
    height: 60px;
    max-width: 190px;
    object-fit: contain;
  }
  .footer-area .copyright {
    font-size: 16px;
    font-weight: 300;
    margin-top: 40px;
  }`, "",{"version":3,"sources":["webpack://./src/components/footer/Footer.css"],"names":[],"mappings":";AACA,gBAAgB;AAChB;IACI,yBAAyB;IACzB,kBAAkB;IAClB,oBAAoB;IACpB,WAAW;EACb;EACA;IACE,gBAAgB;IAChB,yBAAyB;IACzB,eAAe;IACf,qBAAqB;IACrB,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,6BAA6B;IAC7B,eAAe;IACf,aAAa;IACb,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,wCAAwC;IACxC,WAAW;IACX,SAAS;EACX;EACA;IACE,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,gBAAgB;EAClB","sourcesContent":["\n/* footer-area */\n.footer-area {\n    background-color: #0b59ae;\n    text-align: center;\n    padding: 70px 0 50px;\n    color: #fff;\n  }\n  .followus_box h4 {\n    font-weight: 600;\n    text-transform: uppercase;\n    font-size: 24px;\n    letter-spacing: 0.5px;\n    margin-bottom: 5px;\n  }\n  .followus_box a {\n    color: #fff;\n    font-size: 30px;\n  }\n  \n  .footer-menu ul li a {\n    color: rgb(255 255 255 / 79%);\n    font-size: 16px;\n    padding: 14px;\n    display: inline-block;\n    position: relative;\n    font-weight: 300;\n  }\n  .footer-menu ul li a:hover {\n    color: #fff;\n  }\n  .footer-menu ul li:last-child a::after {\n    display: none;\n  }\n  .footer-menu ul li a::after {\n    content: \"\";\n    position: absolute;\n    width: 1px;\n    height: 18px;\n    background-color: rgb(255 255 255 / 46%);\n    right: -5px;\n    top: 16px;\n  }\n  .footer-area .appbox {\n    margin: 15px 0;\n  }\n  .footer-area .appbox h4 {\n    margin-bottom: 15px;\n    font-size: 24px;\n    font-weight: 600;\n  }\n  .footer-area .appbox img {\n    height: 60px;\n    max-width: 190px;\n    object-fit: contain;\n  }\n  .footer-area .copyright {\n    font-size: 16px;\n    font-weight: 300;\n    margin-top: 40px;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
